<template>
  <div class="TextPage">
    <el-form ref="form" :model="formData" label-width="80px">
      <el-form-item label="题干:">
        <el-input type="textarea" v-model="form.title"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addLessonContentMixins } from "@/pages/MyOutLine/addLessonContentMixins";

export default {
  name: "TextPage",
  mixins: [addLessonContentMixins],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
.TextPage {
  .changeTitleTypeBox {
    display: flex;
    justify-content: space-between;
  }
  ::v-deep .el-textarea__inner {
    min-height: 100px !important;
  }
}
</style>
